// src/components/ajuda/ajudaConteudo.js
// Tudo o que a Central de ajuda e o tour guiado mostram fica neste arquivo.
// Para mudar um texto, incluir uma pergunta ou um passo do tour, edite aqui:
// não é preciso mexer nos componentes.

export const ROTAS = {
  home: "/painel-cliente",
  catalogo: "/painel-cliente/catalogo-premios",
  carrinho: "/painel-cliente/carrinho-resgates",
  pontos: "/painel-cliente/meus-pontos",
  resgates: "/painel-cliente/meus-resgates",
  operacao: "/painel-cliente/cadastrar-operacao",
  campanhas: "/painel-cliente/minhas-campanhas",
  experience: "/painel-cliente/tikpag-experience",
  experiencias: "/painel-cliente/tikpag-experience/experiencias",
  pix: "/painel-cliente/pix",
  perfil: "/painel-cliente/perfil",
  regras: "/painel-cliente/regras",
  eventos: "/painel-cliente/eventos",
};

export const NOMES_PAGINAS = {
  [ROTAS.home]: "Início",
  [ROTAS.catalogo]: "Catálogo de prêmios",
  [ROTAS.carrinho]: "Carrinho",
  [ROTAS.pontos]: "Meus pontos",
  [ROTAS.resgates]: "Meus resgates",
  [ROTAS.operacao]: "Cadastrar operação",
  [ROTAS.campanhas]: "Campanhas",
  [ROTAS.experience]: "Tikpag Experience",
  [ROTAS.experiencias]: "Experiências",
  [ROTAS.pix]: "Pix Premiado",
  [ROTAS.perfil]: "Meu perfil",
  [ROTAS.regras]: "Regras do programa",
  [ROTAS.eventos]: "Eventos",
};

/*
  Passos do tour, por página.
  - alvo: seletor CSS do elemento destacado. Pode ser uma lista: o tour usa o
    primeiro que estiver visível (útil quando o desktop e o celular mostram
    elementos diferentes). Sem alvo = balão centralizado.
  - Passos cujo alvo não existe na tela são pulados automaticamente
    (ex.: aviso de pontos vencendo quando o cliente não tem pontos vencendo).
*/
export const TOURS = {
  [ROTAS.home]: [
    {
      titulo: "Bem-vindo ao TikPontos!",
      texto:
        "Em menos de um minuto mostramos onde fica cada coisa. Você pode pular o tour quando quiser.",
    },
    {
      alvo: '[data-tour="saldo"]',
      titulo: "Seu saldo de pontos",
      texto:
        "Aqui você vê quantos pontos pode trocar agora, quanto falta para o próximo nível e os atalhos para trocar pontos ou cadastrar uma operação.",
    },
    {
      alvo: ['[data-tour="menu-desktop"]', '[data-tour="menu-mobile"]'],
      titulo: "Menu principal",
      texto:
        "Use o menu para ir ao catálogo de prêmios, ao extrato de pontos, aos seus resgates e às campanhas. No celular, o botão Mais mostra as outras opções.",
    },
    {
      alvo: '[data-tour="avisos"]',
      titulo: "Avisos importantes",
      texto:
        "Pontos perto de vencer e o andamento dos seus pedidos aparecem aqui, sem você precisar procurar.",
    },
    {
      alvo: '[data-tour="premios"]',
      titulo: "Prêmios para você",
      texto:
        "Veja os prêmios que já cabem no seu saldo e quanto falta para os outros. Clique em um prêmio para ver os detalhes.",
    },
    {
      alvo: '[data-tour="carrinho"]',
      titulo: "Seu carrinho",
      texto:
        "Os prêmios que você adiciona ficam no carrinho até você finalizar o resgate.",
    },
    {
      alvo: '[data-tour="ajuda"]',
      titulo: "Ajuda sempre à mão",
      texto:
        "Ficou com dúvida? Clique aqui para buscar o que precisa ou refazer este tour quando quiser.",
    },
  ],

  [ROTAS.catalogo]: [
    {
      alvo: '[data-tour="ct-busca"]',
      titulo: "Busque pelo nome",
      texto: "Digite o nome ou o tipo de produto, como panela, fone ou TV.",
    },
    {
      alvo: ['[data-tour="ct-filtros"]', '[data-tour="ct-filtros-mobile"]'],
      titulo: "Filtre os prêmios",
      texto:
        "Escolha uma categoria, uma faixa de pontos, ou mostre só prêmios em promoção ou com frete grátis.",
    },
    {
      alvo: ['[data-tour="ct-saldo"]', '[data-tour="ct-saldo-mobile"]'],
      titulo: "Só o que cabe no saldo",
      texto: "Ligue esta opção para ver apenas os prêmios que você já pode resgatar.",
    },
    {
      alvo: '[data-tour="ct-card"]',
      titulo: "Escolha a quantidade e adicione",
      texto:
        "Cada prêmio mostra quantos pontos custa e quanto falta, se for o caso. Clique na foto ou no nome para ver os detalhes.",
    },
    {
      alvo: ['[data-tour="ct-carrinho"]', '[data-tour="carrinho"]'],
      titulo: "Finalize no carrinho",
      texto:
        "Quando terminar de escolher, abra o carrinho para conferir o frete e finalizar o resgate.",
    },
  ],

  [ROTAS.carrinho]: [
    {
      alvo: ".checkout-itens",
      titulo: "Seus prêmios",
      texto: "Ajuste a quantidade ou remova itens. O frete de cada prêmio é calculado aqui.",
    },
    {
      alvo: ".checkout-voltagem-box",
      titulo: "Escolha a voltagem",
      texto: "Alguns prêmios exigem a escolha de 110V ou 220V antes de finalizar.",
    },
    {
      alvo: ".resumo-carrinho",
      titulo: "Resumo do pedido",
      texto: "Confira o total de pontos e quanto vai sobrar do seu saldo.",
    },
    {
      alvo: ".carrinho-container .btn-finalizar",
      titulo: "Finalize o resgate",
      texto:
        "Ao confirmar, os pontos ficam reservados e você acompanha a entrega em Meus resgates.",
    },
  ],

  [ROTAS.pontos]: [
    {
      alvo: '[data-tour="mp-saldo"]',
      titulo: "Resumo dos pontos",
      texto:
        "Disponíveis são os que você pode trocar agora. Reservados estão presos em resgates ainda não concluídos.",
    },
    {
      alvo: '[data-tour="mp-expiracao"]',
      titulo: "Pontos perto de vencer",
      texto: "Fique de olho nesta lista para não perder pontos.",
    },
    {
      alvo: '[data-tour="mp-filtros"]',
      titulo: "Filtre o extrato",
      texto: "Busque por período, status ou número do pedido.",
    },
    {
      alvo: '[data-tour="mp-historico"]',
      titulo: "Seu extrato",
      texto: "Cada linha mostra de onde vieram os pontos, quando entraram e quando vencem.",
    },
    {
      alvo: '[data-tour="mp-exportar"]',
      titulo: "Baixe em Excel",
      texto: "Exporte o extrato filtrado para uma planilha.",
    },
  ],

  [ROTAS.resgates]: [
    {
      alvo: '[data-tour="mr-filtros"]',
      titulo: "Encontre um pedido",
      texto: "Busque pelo nome do prêmio ou filtre pelo status do pedido.",
    },
    {
      alvo: '[data-tour="mr-card"]',
      titulo: "Acompanhe a entrega",
      texto:
        "Cada pedido mostra a etapa atual: pedido, preparação, transporte e enviado, com a data de cada uma.",
    },
  ],

  [ROTAS.operacao]: [
    {
      alvo: ".cadastrar-operacao-container .info-banner",
      titulo: "Antes de começar",
      texto: "Leia as orientações sobre quais operações geram pontos.",
    },
    {
      alvo: ".cadastrar-operacao-container .form-col-left",
      titulo: "Dados da operação",
      texto: "Informe o pedido e os dados pedidos. Alguns campos são preenchidos automaticamente.",
    },
    {
      alvo: ".cadastrar-operacao-container .pts-estimados",
      titulo: "Pontos estimados",
      texto: "Veja quantos pontos a operação deve gerar depois de aprovada.",
    },
    {
      alvo: ".cadastrar-operacao-container .form-operacao .btn.azul",
      titulo: "Envie para análise",
      texto: "Os pontos aparecem como em análise até a aprovação.",
    },
  ],

  [ROTAS.pix]: [
    {
      alvo: ".pixc-rules",
      titulo: "Como funciona",
      texto: "Leia as regras e as faixas do Pix Premiado.",
    },
    {
      alvo: ".pixc-grid .pixc-card",
      titulo: "Faça sua solicitação",
      texto: "Preencha os dados para solicitar o Pix.",
    },
    {
      alvo: ".pixc-table-wrap",
      titulo: "Acompanhe",
      texto: "Veja o status e o pagamento de cada solicitação.",
    },
  ],

  [ROTAS.perfil]: [
    {
      alvo: ".meuPerfil-section",
      titulo: "Seus dados",
      texto: "Mantenha nome, e-mail e telefone atualizados para receber avisos dos seus resgates.",
    },
    {
      alvo: ".meuPerfil-confirmacoes",
      titulo: "Confirme os dados",
      texto: "Marque a confirmação antes de salvar.",
    },
    {
      alvo: ".meuPerfil-actions button",
      titulo: "Salve as alterações",
      texto: "Pronto! Seus dados ficam atualizados na hora.",
    },
  ],
};

/*
  Perguntas da Central de ajuda.
  - chaves: palavras que o cliente pode digitar (sem acento, minúsculas).
  - rota: para onde o cliente vai ao clicar.
*/
export const PERGUNTAS = [
  {
    pergunta: "Como troco meus pontos por prêmios?",
    rota: ROTAS.catalogo,
    chaves: "trocar troca resgatar resgate premio premios catalogo comprar produto usar pontos",
    destaque: true,
  },
  {
    pergunta: "Onde vejo meu saldo e o extrato de pontos?",
    rota: ROTAS.pontos,
    chaves: "saldo extrato pontos historico quanto tenho credito creditos",
    destaque: true,
  },
  {
    pergunta: "Meus pontos vão vencer?",
    rota: ROTAS.pontos,
    chaves: "expirar expira expiracao vencer vence vencimento validade perder",
    destaque: true,
  },
  {
    pergunta: "Como cadastro uma operação para ganhar pontos?",
    rota: ROTAS.operacao,
    chaves: "operacao operacoes cadastrar registrar venda locacao pontuar ganhar acumular pedido",
    destaque: true,
  },
  {
    pergunta: "Onde acompanho a entrega do meu prêmio?",
    rota: ROTAS.resgates,
    chaves: "entrega entregar rastrear rastreio pedido pedidos resgate status chegou transporte enviado prazo",
    destaque: true,
  },
  {
    pergunta: "Meu prêmio chegou com defeito. O que faço?",
    rota: ROTAS.resgates,
    chaves: "defeito quebrado quebrou danificado avaria troca devolucao devolver problema errado",
  },
  {
    pergunta: "Por que tenho pontos reservados?",
    rota: ROTAS.pontos,
    chaves: "reservado reservados bloqueado preso pendente",
  },
  {
    pergunta: "Como finalizo um resgate?",
    rota: ROTAS.carrinho,
    chaves: "carrinho finalizar checkout concluir confirmar resgate",
  },
  {
    pergunta: "Como escolho a voltagem do prêmio?",
    rota: ROTAS.carrinho,
    chaves: "voltagem 110 220 bivolt tensao",
  },
  {
    pergunta: "Quanto custa o frete?",
    rota: ROTAS.carrinho,
    chaves: "frete entrega gratis custo envio",
  },
  {
    pergunta: "Como funciona o Pix Premiado?",
    rota: ROTAS.pix,
    chaves: "pix premiado dinheiro transferencia",
  },
  {
    pergunta: "Como participo das campanhas?",
    rota: ROTAS.campanhas,
    chaves: "campanha campanhas meta metas inscricao inscrever participar cancelar",
  },
  {
    pergunta: "O que é o Tikpag Experience?",
    rota: ROTAS.experience,
    chaves: "experience experiencia experiencias pin pins jornada volume",
  },
  {
    pergunta: "Quais experiências posso ganhar?",
    rota: ROTAS.experiencias,
    chaves: "experiencias vitrine viagem passeio jantar",
  },
  {
    pergunta: "Como subo de nível?",
    rota: ROTAS.regras,
    chaves: "nivel niveis categoria start silver gold subir perfil cartao",
  },
  {
    pergunta: "Como altero meus dados cadastrais?",
    rota: ROTAS.perfil,
    chaves: "perfil dados cadastro alterar email telefone cpf cnpj nome atualizar",
  },
  {
    pergunta: "Quais são as regras do programa?",
    rota: ROTAS.regras,
    chaves: "regras regulamento termos funciona programa intransferivel",
  },
  {
    pergunta: "Onde vejo os eventos?",
    rota: ROTAS.eventos,
    chaves: "evento eventos sorteio sorteios",
  },
];

export const PALAVRAS_IGNORADAS = new Set([
  "como", "onde", "que", "qual", "quais", "para", "por", "meu", "meus", "minha",
  "minhas", "uma", "uns", "umas", "dos", "das", "com", "sem", "tem", "ter",
  "quero", "posso", "fazer", "faco", "vejo", "ver", "esta", "estao", "nao",
  "mais", "sobre", "isso", "esse", "essa", "aqui", "voce", "de", "do", "da",
  "em", "no", "na", "um", "os", "as", "ao", "se", "eu", "me", "quando", "porque",
]);
